/** Grabs the host app name from the window object.
 * Lots of scary chaining inside - expect no type safety.
 * Mostly used for usage tracking.
 *
 * Returns "local" if the iframe is cross-origin. For example, if the parent app is running
 * locally and `marketplace-embed` is not, or vice versa.
 *
 * @param w - Defaults to the `window` global. Pass `window.parent` if calling from an iframe.
 */
export function getHostAppName(w) {
  try {
    var _ref;
    return (_ref = w !== null && w !== void 0 ? w : window) === null || _ref === void 0 || (_ref = _ref.hubspot) === null || _ref === void 0 || (_ref = _ref.bender) === null || _ref === void 0 ? void 0 : _ref.currentProject;
  } catch (e) {
    return 'local';
  }
}